import React, { useEffect } from "react";
import { googleAnalyticsActions } from "../../utils/ga";
import ProductItemComponent from "../../components/ProductItemComponent";
import TopNavComponent from "../../components/TopNavComponent";
import FooterComponent from "../../components/FooterComponent";
import ProductItemChickenJelly from "../../components/ProductItemChickenJelly";
import ProductItemChickenGravy from "../../components/ProductItemChickenGravy";
import ProductItemJustTunaJelly from "../../components/ProductItemJustTunaJelly";
import ProductItemJustTunaGravy from "../../components/ProductItemJustTunaGravy";
import ProductItemShirasuJelly from "../../components/ProductItemShirasuJelly";
import ProductItemShirasuGravy from "../../components/ProductItemShirasuGravy";
import ProductItemSalmonJelly from "../../components/ProductItemSalmonJelly";
import ProductItemSalmonGravy from "../../components/ProductItemSalmonGravy";
import { Switch, Route, useRouteMatch, Link } from "react-router-dom";
import MobileNavComponent from "../../components/MobileNavComponent";

import "./styles.css";

export default function ProductItemScreen() {
  const { path } = useRouteMatch();

  useEffect(() => {
    googleAnalyticsActions.initGoogleAnalytics();
  }, []);

  return (
    <>
      <MobileNavComponent />
      <div className="product">
        <header class="product-top-nav">
          <TopNavComponent />
        </header>
        <main className="product-main">
          <Switch>
            <Route exact path={`${path}`}>
              <ProductItemComponent />
            </Route>
            <Route exact path={`${path}/chicken-jelly`}>
              <ProductItemChickenJelly />
            </Route>
            <Route exact path={`${path}/chicken-gravy`}>
              <ProductItemChickenGravy />
            </Route>
            <Route exact path={`${path}/just-tuna-jelly`}>
              <ProductItemJustTunaJelly />
            </Route>
            <Route exact path={`${path}/just-tuna-gravy`}>
              <ProductItemJustTunaGravy />
            </Route>
            <Route exact path={`${path}/shirasu-jelly`}>
              <ProductItemShirasuJelly />
            </Route>
            <Route exact path={`${path}/shirasu-gravy`}>
              <ProductItemShirasuGravy />
            </Route>
            <Route exact path={`${path}/salmon-jelly`}>
              <ProductItemSalmonJelly />
            </Route>
            <Route exact path={`${path}/salmon-gravy`}>
              <ProductItemSalmonGravy />
            </Route>
          </Switch>
        </main>
        <footer className="product-footer">
          <FooterComponent />
        </footer>
      </div>
    </>
  );
}
